/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, onConnect } from '@reatom/framework'

import { AsyncStateN, Result } from '@blade/std-lib'
import { isLoggedInAtom } from '@root/entities/auth'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { pairRegistry } from '@root/entities/pair/atoms'
import { reatomRequest } from '@root/shared/lib'

import { fetchUserRecentSearchesRequestAction } from './recent-searches-requests'

import type { PairAddress } from '@root/entities/pair'

const reatomRecentSearchesPairs = (network: Network.Network) => {
  const loadAction = action(async (ctx) => {
    const isLoggedIn = ctx.get(isLoggedInAtom)
    if (!isLoggedIn) {
      return Result.succeed([])
    }

    const result = await ctx.schedule(() =>
      fetchUserRecentSearchesRequestAction(ctx, { network }),
    )

    const mappedResult = result.pipe(
      Result.map((it) =>
        it.map((dto) => pairRegistry.resolveFromDto(ctx, dto)),
      ),
    )

    return mappedResult
  })

  const recentSearchesAtom = reatomRequest({
    execAction: loadAction,
    name: `${network}_recentSearches`,
  })

  const deleteRecentSearchAction = action(
    async (ctx, req: { pairAddress: PairAddress }) => {
      const state = ctx.get(recentSearchesAtom)

      recentSearchesAtom(
        ctx,
        AsyncStateN.map(state, (pairs) =>
          pairs.filter((it) => it.address !== req.pairAddress),
        ),
      )
    },
    'deleteRecentSearchAction',
  )

  onConnect(recentSearchesAtom, (ctx) => {
    const state = ctx.get(recentSearchesAtom)
    if (AsyncStateN.isSuccess(state)) {
      recentSearchesAtom.refresh(ctx, { strategy: 'success-only' })
      return
    }
    recentSearchesAtom.execute(ctx)
  })

  return {
    recentSearchesAtom,
    deleteRecentSearchAction,
  }
}

export const recentSearchesModelByNetwork = Network.byNetworkRecord((network) =>
  reatomRecentSearchesPairs(network),
)

export const recentSearchesModelAtom = atom((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  return recentSearchesModelByNetwork[network]
}, 'recentSearchesModelAtom')
